import React, { memo, useState } from 'react';
import {
    Button,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Input,
    Label,
    Form,
    FormGroup,
} from 'reactstrap';
import IntlMessages from '../../../helpers/IntlMessages';
import PerfectScrollbar from 'react-perfect-scrollbar';

import Select from 'react-select';
import Creatable from '../../../components/common/CreatableSelect';
import CustomSelectInput from '../../../components/common/CustomSelectInput';
import { GetSelectTime, SetSelectTime } from '../../../helpers/SelectTime';
import { AddCommaNumber } from '../../../helpers/Utils';
import DynamicForm from '../general/DynamicForm';
import TooltipItem from '../../../components/common/TooltipItem';
import {
    getCashFlowCreateFormConfig,
    getCashFlowProviderOptions,
} from '../../../helpers/cashFlowForm';

const ContentComponent = ({
    title,
    isOpen,
    toggle,
    onSubmit,
    data_dynamic_form,
    values,
    setting,
    onChange,
    onChangeDynamicForm,
}) => {
    const formConfig = getCashFlowCreateFormConfig(values.voucherTemplate, 'outcome');
    const providerOptions = getCashFlowProviderOptions(values.voucherTemplate, 'outcome');
    const selectedProvider = values.name
        ? { label: values.name, value: values.name }
        : null;
    // console.log('render AddComponent');
    const [timeTooltip] = useState({
        placement: 'top',
        text: '',
        body: 'Nếu chọn "Đưa vào thống kê" thì số liệu này sẽ được tính như một khoản chi trong ngày. Nếu chọn "Không đưa vào thống kê" thì chỉ xem như một con số tượng trưng.',
    });
    return (
        <Modal
            isOpen={isOpen}
            toggle={toggle}
            wrapClassName='modal-right'
            backdrop={true}
            autoFocus={false}
        >
            <Form onSubmit={(e) => onSubmit(e)}>
                <ModalHeader toggle={toggle}>{title}</ModalHeader>
                <ModalBody className='scrool modal-right-add'>
                    <PerfectScrollbar
                        options={{
                            suppressScrollX: true,
                            wheelPropagation: false,
                        }}
                        id='modal-right__body'
                    >
                        <FormGroup className='mt-3 has-float-label'>
                            <Label for='sub_title' className='text-muted'>
                                {formConfig.titleLabel}<span style={{color: 'red'}}>*</span>
                            </Label>
                            <Input
                                autoFocus={true}
                                type='text'
                                name='sub_title'
                                id='sub_title'
                                placeholder={formConfig.titlePlaceholder}
                                disabled={setting.viewonly && !setting.add}
                                value={values.sub_title}
                                onChange={onChange}
                            />
                        </FormGroup>
                        <FormGroup className='has-float-label'>
                            <Label for='name' className='text-muted'>
                                {formConfig.partyLabel}<span style={{color: 'red'}}>*</span>
                            </Label>
                            {providerOptions.length > 0 ? (
                                <Creatable
                                    components={{ Input: CustomSelectInput }}
                                    className='react-select'
                                    classNamePrefix='react-select'
                                    name='name'
                                    inputId='name'
                                    value={selectedProvider}
                                    options={providerOptions}
                                    isDisabled={setting.viewonly && !setting.add}
                                    placeholder={formConfig.partyPlaceholder}
                                    formatCreateLabel={(inputValue) => `Sử dụng nhà cung cấp: "${inputValue}"`}
                                    onChange={(option) => onChange(option || { value: '' }, 'name')}
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                    }}
                                />
                            ) : (
                                <Input
                                    type='text'
                                    name='name'
                                    id='name'
                                    placeholder={formConfig.partyPlaceholder}
                                    disabled={setting.viewonly && !setting.add}
                                    value={values.name}
                                    onChange={onChange}
                                />
                            )}
                        </FormGroup>
                        <FormGroup className='has-float-label'>
                            <Label for='address' className='text-muted'>
                                {formConfig.addressLabel}
                            </Label>
                            <Input
                                type='text'
                                name='address'
                                id='address'
                                placeholder={formConfig.addressPlaceholder}
                                disabled={setting.viewonly && !setting.add}
                                value={values.address}
                                onChange={onChange}
                            />
                        </FormGroup>
                        <FormGroup className='has-float-label'>
                            <Label for='value' className='text-muted'>
                                {formConfig.amountLabel}<span style={{color: 'red'}}>*</span>
                            </Label>
                            <Input
                                type='text'
                                inputMode='numeric'
                                autoComplete='off'
                                name='value'
                                id='value'
                                placeholder={formConfig.amountPlaceholder}
                                disabled={setting.viewonly && !setting.add}
                                value={AddCommaNumber(values.value)}
                                onChange={onChange}
                            />
                        </FormGroup>
                        <FormGroup className='has-float-label'>
                            <Label for='note' className='text-muted'>
                                {formConfig.noteLabel}
                            </Label>
                            <Input
                                type='text'
                                name='note'
                                id='note'
                                placeholder={formConfig.notePlaceholder}
                                disabled={setting.viewonly && !setting.add}
                                value={values.note}
                                onChange={onChange}
                            />
                        </FormGroup>
                        {values.alias ? null : (
                            <FormGroup className='has-float-label'>
                                <Label for='time' className='text-muted'>
                                    <IntlMessages id='time' /><span style={{color: 'red'}}>*</span>
                                    <TooltipItem item={timeTooltip} id={8} />
                                </Label>
                                <Select
                                    components={{ Input: CustomSelectInput }}
                                    className='react-select'
                                    classNamePrefix='react-select'
                                    name='time'
                                    value={GetSelectTime(values.time)}
                                    isDisabled={
                                        setting.viewonly && !setting.add
                                    }
                                    placeholder={
                                        <IntlMessages id='select-one-time' />
                                    }
                                    options={SetSelectTime()}
                                    onChange={(e) => {
                                        onChange(e, 'time');
                                    }}
                                />
                            </FormGroup>
                        )}
                        {/* {setting.update ? (
        <FormGroup>
          <Label for="GetSelectTime(values.time)">
            <IntlMessages id="user.created" />
          </Label>
          <Input type="text" name="user.created" id="user.created"
            disabled={true}
            value={values.user}
            onChange={onChange}
          />
        </FormGroup>
      ) : null} */}

                        <DynamicForm
                            values={values.dynamic_form}
                            data={data_dynamic_form}
                            onChange={onChangeDynamicForm}
                            disabled={setting.viewonly && !setting.add}
                        />
                    </PerfectScrollbar>
                </ModalBody>
                <ModalFooter>
                    <Button color='primary'>
                        <IntlMessages id='outcome.btn-add' />
                    </Button>{' '}
                </ModalFooter>
            </Form>
        </Modal>
    );
};

export default memo(ContentComponent);
